// extracted by mini-css-extract-plugin
export var box = "_8u-1";
export var checkboxRow = "_8u-8";
export var checked = "_8u-2";
export var descriptionSpacer = "_8u-a";
export var disabled = "_8u-3";
export var icon = "_8u-6";
export var input = "_8u-0";
export var labelSpacer = "_8u-9";
export var medium = "_8u-5";
export var small = "_8u-4";
export var text = "_8u-7";